import { render, staticRenderFns } from "./modal_edit_topic.vue?vue&type=template&id=725f431c"
import script from "./modal_edit_topic.vue?vue&type=script&lang=js"
export * from "./modal_edit_topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports